import api from 'apis/restaurant-api/api';
import { RestaurantApiResults } from 'apis/restaurant-api/types';

import { SearchResult } from './types';

export const searchVenues = (searchString: string) =>
  api
    .get<RestaurantApiResults<SearchResult>>('/v1/merchant-admin/search', { params: { q: searchString } })
    .then(response => response.data.results);
